import { Link, useRouteLoaderData } from '@remix-run/react'
import { useSanityImages } from '~/hooks'
import type { RootDataProps } from '~/types'

interface Props {
  className?: string
}

const HeaderSimple = ({ className = '' }: Props) => {
  const { site } = useRouteLoaderData('root') as RootDataProps

  const { urlFor } = useSanityImages()
  const logoUrl = site?.global?.logo?.asset
    ? urlFor(site.global.logo).height(56).auto('format').url()
    : null

  if (!logoUrl) return null

  return (
    <div className={`bg-neutral-50 ${className}`}>
      <div className="container pt-6">
        <div className="flex justify-center">
          <Link
            to="/"
            aria-label="Home"
          >
            <img
              src={logoUrl}
              alt={site?.global?.logo?.alt ?? 'Site logo'}
              className="h-14 w-auto"
              height={56}
              width="auto"
              loading="eager"
            />
          </Link>
        </div>
      </div>
    </div>
  )
}

export default HeaderSimple
